import React, { useState } from 'react';
import apiClient from '../../../../../../Services/ApiClient';
import useApiClient from '../../../../../Base/Hooks/useApiClient';
import { useManagerContext } from '../../../../Services/ManagerContext';
import Loading from '../../../../../../Components/Loading';
import ManagerAddWorkerByRegistrationForm, {
	ManagerAddWorkerByRegistrationFormValues,
} from './ManagerAddWorkerByRegistrationForm';

interface Role {
	value: string;
	label: string;
}

interface Workplace {
	workplace: {
		value: string;
		label: string;
	};
	role: Role[];
}

interface WorkplaceMembers {
	workplaceId: string;
	roleId: string[];
}

interface Props {
	onCreate: () => void;
}

const ManagerAddWorkerByRegistration: React.FC<Props> = ({ onCreate }) => {
	const { displayError } = useApiClient();
	const { rootWorkplaceId } = useManagerContext();
	const [isLoading, setIsLoading] = useState(false);

	function transformWorkplaces(input: Workplace[]): WorkplaceMembers[] {
		return input.map(({ workplace, role }) => ({
			workplaceId: workplace.value,
			roleId: role.map(r => r.value),
		}));
	}

	const handleSubmit = async (
		values: ManagerAddWorkerByRegistrationFormValues,
	) => {
		setIsLoading(true);
		if (rootWorkplaceId) {
			const { workplaces, ...restOfValues } = values;
			try {
				const response = await apiClient.post(
					`/workplaces/${rootWorkplaceId}/members/invitation`,
					{
						user: restOfValues,
						workplaceMembers: transformWorkplaces(workplaces),
					},
				);
				if (response.status === 200) {
					onCreate();
				}
			} catch (e) {
				displayError(e);
			}
		}
		setIsLoading(false);
	};

	if (isLoading) {
		return <Loading />;
	}

	return <ManagerAddWorkerByRegistrationForm onSubmit={handleSubmit} />;
};

export default ManagerAddWorkerByRegistration;
